<app-navbar></app-navbar>
<ng-container *ngIf="foundnews != null">

    <div class="page-title-area" style="height: 0px !important;"></div>

    <div style="margin-bottom: 50px">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="page-title-content">
                        <h2 style="color: white;">{{foundnews.TitleEn}}</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container card" style="padding: 20px;">
        <br>
        <br>
        <div class="container" style="text-align: center;">
            <div class="row">
                <div class="col-md-12">
                    <p class="details-content">
                        <span style="text-align: justify !important; color: white;" [innerHTML]="foundnews.DetailsEn">
                        </span>
                    </p>
                </div>
            </div>
            <div class="container">
                <div class="container">
                    <div class="gallery-container">
                        <div class="gallery">
                            <a *ngFor="let image of foundnews.ShowAttachments" class="gallery__item"
                                href="{{ image.FilePath }}" [title]="image.FilePath">
                                <img [src]="image.FilePath" [alt]="image.FilePath" class="popup-btn"
                                    style="max-width: 300px; max-height: 200px; padding: 10px;" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>